import { createEffect, createSignal } from "solid-js";
import { LoadingButton } from "../../components/ui/Button";
import { TextInput } from "../../components/ui/form/TextInput";
import { DateInput } from "../../components/ui/form/DateInput";
import { ComboBoxInput } from "../../components/ui/form/ComboBoxInput";
import { Modal } from "../../components/ui/Modal";
import { DialogFooter } from "@/components/shadcn/dialog";
import usePaymentForm from "../../services/usePaymentForm";

export const PaymentModal = (props) => {

  const [open, setOpen] = createSignal(false);
  const [title, setTitle] = createSignal('');
  const onClose = (state) => {
    if (typeof props.onClose === 'function') {
      props.onClose();
    }
  }

  const onRefresh = () => {
    if (typeof props.onRefresh === 'function') {
      props.onRefresh();
    }
  }

  const {
    form,
    handleInput,
    handleChange,
    handleSave,
    fetchInfo,
    appointments,
    loading,
    fetching,
    clearForm,
  } = usePaymentForm({ onClose, onRefresh });

  createEffect(() => {
    props.open;
    setOpen(props.open);
  });

  createEffect(() => {
    props.key;
    if (props.key !== null) {
      fetchInfo(props.key);
      setTitle('Edit Payment');
    } else {
      clearForm(props.appointmentId ?? null);
      setTitle('New Payment');
    }
  });

  return (
    <Modal
      class="w-full lg:w-[500px] max-w-full"
      open={open()}
      title={title()}
      onClose={onClose}
      fetching={fetching()}
      hideOnOutsideClick={false}
      error={''}
    >
      <div class="grid grid-cols-2 gap-2">
        <div class="">
          <DateInput
            label="Date"
            name="date"
            form={form}
            input={handleChange}
          />
        </div>
        <div class="">
          <ComboBoxInput
            label="Appointment"
            name="appointmentId"
            form={form}
            input={handleChange}
            datasource={{
              type: 'local',
              data: appointments(),
              text: 'text',
              value: 'value',
              disabled: 'disabled'
            }}
          />
        </div>
        <div class="">
          <TextInput
            type="number"
            label="Amount"
            name="amount"
            form={form}
            input={handleChange}
          />
        </div>
        <div class="">
          <TextInput
            type="number"
            label="Discount"
            name="discount"
            form={form}
            input={handleChange}
          />
        </div>
      </div>
      <DialogFooter>
        <LoadingButton variant="outline" onClick={() => { handleSave() }} type="button" loading={loading()} disabled={fetching()}>Save</LoadingButton>
      </DialogFooter>
    </Modal>
  );
}
